import React, { useEffect, useState } from 'react';
import { Button, Box, Container, TextField, Typography } from '@mui/material';

import './AskEPCUsersRequest.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkPendingRequests,
  requestEPCPermission,
} from '../../store/actions/userPermissions/userPermissions';
import { getSafe } from '../../shared/utility';
import {
  USER_DATA,
  USER_PERMISSIONS,
} from '../../shared/const/Routes/statePaths';

const AskEPCUsersRequest = () => {
  const dispatch = useDispatch();

  const userData = useSelector(state => getSafe(USER_DATA, state));
  const userPermissions = useSelector(state =>
    getSafe(USER_PERMISSIONS, state)
  );

  const [justification, setJustification] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    dispatch(checkPendingRequests(userData.idsid));
  }, []);

  const handleClick = () => {
    if (!justification.trim()) {
      setError(true);
      return;
    }
    setError(false);
    dispatch(requestEPCPermission(userData.wwid, justification));
  };

  const renderInterface = () => {
    if (
      !Object.prototype.hasOwnProperty.call(
        userPermissions,
        'permissionRequested'
      )
    )
      return null;
    if (userPermissions?.permissionRequested) {
      return (
        <Typography variant="h6" color="textSecondary" align="center">
          Permission requested, awaiting approval.
        </Typography>
      );
    } else {
      return (
        <Box display="flex" flexDirection="column" gap={2} width="400px">
          <TextField
            label="Justification"
            multiline
            minRows={3}
            value={justification}
            onChange={e => setJustification(e.target.value)}
            variant="outlined"
            fullWidth
            error={error}
            helperText={
              error
                ? 'You must fill the justification before requesting access.'
                : ''
            }
          />
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleClick}
          >
            Request Access
          </Button>
        </Box>
      );
    }
  };

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      {renderInterface()}
    </Container>
  );
};

export default AskEPCUsersRequest;
